<template>
  <v-container>
    <carga-ciclo-semestre titulo="Tutorías" :datos="periodo" />

    <v-divider />

    <v-card
      ><v-card-text>
        <v-row
          ><v-col cols="12" sm="4"
            ><v-select
              v-model="turno"
              :items="[
                { text: 'VESPERTINO', value: 'TV' },
                { text: 'MATUTINO', value: 'TM' },
              ]"
              label="Turno"
              required
          /></v-col>
        </v-row>
      </v-card-text>
      <template>
        <v-tabs show-arrows fixed-tabs v-model="tabSelected">
          <v-tab v-for="(sem, idx) in itemsSemestres" :key="idx">
            {{ sem.text }}
          </v-tab>
        </v-tabs>
      </template>

      <v-divider />

      <v-card-text>
        <v-card v-for="grupo in itemsGrupos" :key="grupo.id" class="mb-4">
          <v-card-title class="secondary py-1"
            >Grupo
            {{
              grupo.semestre +
              "&deg; " +
              grupo.letra +
              " " +
              grupo.turno +
              " - " +
              grupo.nombre
            }}</v-card-title
          >
          <v-card-text>
            <v-row class="border-bottom" align="center">
              <v-col cols="6" sm="3" md="2"
                ><p class="text-center py-0 my-0">TUTORIA</p></v-col
              >
              <v-col
                cols="12"
                sm="9"
                md="10"
                v-for="c in itemsCarga(
                  tutorias,
                  grupo.turno,
                  grupo.semestre,
                  grupo.letra
                )"
                :key="c.id"
                align="center"
                class="border-top"
              >
                <p class="text-center py-0 my-0">
                  <v-select
                    hide-details
                    v-model="c.docente_id"
                    :items="itemsDocentes"
                    required
                    @blur="docenteBlur"
                    @focus="docenteFocus(c.docente_id)"
                    @change="
                      docenteSeleccionado(
                        c.tutoria_id,
                        c.periodo_id,
                        c.grupo_id,
                        c.docente_id
                      )
                    "
                  /></p
              ></v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>

    <loading-wait :loading="loading" />

    <v-snackbar v-model="snackbar" multi-line :timeout="snacktime">
      <v-row no-gutters>
        <v-col cols="12"
          ><strong>{{ docFocus ? docFocus.nombre : "" }}</strong></v-col
        >
        <v-col cols="6"
          >Plaza:
          <strong>{{ docFocus ? docFocus.plaza_horas : "" }}</strong>
          horas<br />Máximo frente a grupo:
          <strong>{{ docFocus ? docFocus.maximo_horas : "" }}</strong>
          horas</v-col
        >
        <v-col cols="6"
          >Asignado:<br />
          <ul>
            <li>
              <strong>{{ docFocus ? docFocus.grupos : "" }}</strong> grupo(s)
              para un total de
              <strong>{{ docFocus ? docFocus.horas : "" }}</strong> horas
            </li>
          </ul></v-col
        >
        <v-col cols="12"
          ><p
            class="error my-0"
            v-if="docFocus && docFocus.horas > docFocus.plaza_horas"
          >
            Se ha excedido el número de horas de la plaza.
          </p>
          <p
            class="info my-0"
            v-if="
              docFocus &&
              docFocus.horas <= docFocus.plaza_horas &&
              docFocus.horas > docFocus.maximo_horas
            "
          >
            Se ha excedido el número de horas frente a grupo.
          </p></v-col
        >
      </v-row>
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="snackbar = false"
          >Cerrar</v-btn
        >
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import api from "@/api";
import CargaCicloSemestre from "@/components/CargaCicloSemestre.vue";
import LoadingWait from "@/components/LoadingWait.vue";
import { gets } from "@/mixins/gets";

export default {
  name: "Tutorias",

  components: { CargaCicloSemestre, LoadingWait },

  props: {
    periodoSeleccionado: {
      type: String,
      required: true,
    },
  },

  mixins: [gets],

  data: () => ({
    periodoActual: true,
    periodo: {},
    grupos: {},
    tutorias: {},
    docentes: {},
    carga: {},
    turno: "",
    tabSelected: 0,
    loading: false,
    snackbar: false,
    snacktime: -1,
    docFocus: null,
  }),

  computed: {
    go_fetch() {
      let sel = null;
      if (this.turno != "") {
        sel = this.turno + "-" + this.tabSelected;
      }
      return sel;
    },

    itemsGrupos() {
      if (this.go_fetch) {
        let items = this.grupos;
        let selSems = this.itemsSemestres[this.tabSelected].value;
        let list = [];
        let result = Object.keys(items).map(function (key) {
          if (items[key].semestre == selSems) list.push(items[key]);
          return items[key].semestre;
        });
        return list;
      } else return null;
    },
  },

  watch: {
    async go_fetch(val) {
      if (val) {
        this.tutorias = await this.get("tutorias", {
          id: this.periodo.id,
          turno: this.turno,
        });
        this.carga = await this.get("cargas", {
          id: this.periodo.id,
          turno: this.turno,
        });
      }
    },

    periodoSeleccionado() {
      this.turno = "";
      this.set();
    },
  },

  methods: {
    async set() {
      if (this.periodoSeleccionado == "proximo-periodo") {
        this.periodoActual = false;
      } else if (this.periodoSeleccionado == "periodo-actual") {
        this.periodoActual = true;
      }
      this.periodo = await this.get(
        "periodos",
        this.periodoActual ? "actual" : "proximo"
      );
      this.grupos = await this.getGrupos(this.periodo.id);
      this.docentes = await this.get("docentes", "all", "apellidos, nombre");
    },
  },

  async mounted() {
    this.$store.commit("setPageTitle", "Tutorías");
    this.set();
  },
};
</script>

<style>
.border-bottom {
  border-bottom: 1px solid darkgray;
}
.border-top {
  border-top: 1px solid darkgray;
}
</style>